export default "/images/a4f3e5149f9d01156c815c12b9e06b17.avif";